import Box from "ReusableComponents/Box";
import Logo from "assets/Logo";
import More from "assets/more.svg";
import { useEffect, useState } from "react";

import { useMediaQuery } from "@mui/material";
import { useLanguage } from "LanguageContext";
import Products from "Pages/Landing/components/Products/Products";
import Broucher from "Pages/components/Broucher";
import Button from "ReusableComponents/Button";
import Text from "ReusableComponents/Text";
import { apiClient } from "api/apiClient";
import ArrowDown from "assets/downArrow.svg";
import ArrowDownPrimary from "assets/downarrowPrimary.png";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { activeHeader, showProducts } from "store/actions";
import { COLORS, SIZES, WEIGHT } from "theme";
import Sidebar from "./Sidebar";
import LanguageSelector from "./language-selector";

const Header = () => {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const show = useSelector((state) => {
        // console.log(state?.Landing?.showProducts);
        return state?.Landing?.showProducts;
    });

    const active = useSelector((state) => state?.Landing?.active);
    const smallScreen = useMediaQuery("(max-width: 768px)");
    const medium = useMediaQuery("(max-width: 1024px)");

    const [open, setOpen] = useState(false);
    const [openBroucher, setOpenBroucher] = useState(false);

    const [hover, setHover] = useState(false);
    const [hoverIcon, setHoverIcon] = useState(false);
    const [showDrop, setShowDrop] = useState(false);
    const { selectedLanguage } = useLanguage();

    const language = [
        { value: "EN", name: "English" },
        { value: "HI", name: "हिंदी . Hindi" },
        { value: "TA", name: "தமிழ் . Tamil" },
        { value: "TE", name: "తెలుగు . Telugu" },
        { value: "MR", name: "मराठी . Marathi" },
        { value: "GU", name: "ગુજરાતી . Gujarati" },
        { value: "KN", name: "ಕನ್ನಡ . Kannada" },
        { value: "BN", name: "Bengali" },
    ];
    const [product, setProducts] = useState([]);
    const handleOpenDeawer = () => {
        setOpen(true);
    };

    useEffect(() => {
        apiClient.getProducts().then((res) => {
            setProducts(res?.data);
        });
    }, []);

    useEffect(() => {
        if (window.location.href.includes("charging")) {
            dispatch(showProducts(false));
            setShowDrop(false);

            return dispatch(activeHeader(1));
        }
        if (window.location.href.includes("intelligence")) {
            dispatch(showProducts(false));
            setShowDrop(false);

            return dispatch(activeHeader(2));
        }
        if (window.location.href.includes("showroom-locator")) {
            dispatch(showProducts(false));
            setShowDrop(false);

            return dispatch(activeHeader(3));
        }
        if (window.location.href.includes("news")) {
            dispatch(showProducts(false));
            setShowDrop(false);

            return dispatch(activeHeader(4));
        }
        if (window.location.href.includes("reviews")) {
            dispatch(showProducts(false));
            setShowDrop(false);

            return dispatch(activeHeader(5));
        } else return dispatch(activeHeader(0));
    }, [dispatch]);

    const onClose = () => setOpen(false);
    return (
        <>
            {open && (
                <Sidebar
                    open={open}
                    onClose={onClose}
                    language={language}
                    small={smallScreen}
                    medium={medium}
                />
            )}

            <Box
                h="71px"
                w="auto"
                background="#000000"
                display="flex"
                justifyContent={"start"}
                padding={smallScreen ? "0 20px" : "0 80px"}
                position="fixed"
                left="0"
                right="0"
                zIndex="12"
                component="div"
                onMouseLeave={() => {
                    dispatch(activeHeader(0));
                    dispatch(showProducts(false));
                    setShowDrop(false);
                }}
            >
                {show && (
                    <Products
                        products={product}
                        leave={() => {
                            dispatch(activeHeader(0));
                        }}
                        onClick={() => {
                            dispatch(activeHeader(0));
                            dispatch(showProducts(false));
                        }}
                    />
                )}

                <Box
                    display="flex"
                    alignItems="center"
                    cursor="pointer"
                    onClick={() => {
                        dispatch(activeHeader(0));
                        window.location.href = `/${selectedLanguage}/`;
                    }}
                >
                    <Logo height={smallScreen ? "14" : medium ? "24" : "32"} />
                </Box>

                <Box
                    display="flex"
                    justifyContent={medium ? "end" : "space-between"}
                    alignItems="center"
                    w="100%"
                >
                    <Box
                        display={smallScreen || medium ? "none" : "flex"}
                        alignItems="center"
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            onClick={() => {
                                dispatch(activeHeader(4));
                                dispatch(showProducts(!show));
                            }}
                        >
                            <Text
                                marginRight="13px"
                                cursor="pointer"
                                textColor={
                                    active === 4 ? COLORS.primary : COLORS.white
                                }
                                fontWeight={
                                    active === 4 ? WEIGHT.bold : WEIGHT.regular
                                }
                                fontSize={SIZES.sizteen}
                                marginLeft={SIZES.forty}
                                className="link"
                            >
                                {t("Products")}
                            </Text>
                            <img
                                src={
                                    active === 4 ? ArrowDownPrimary : ArrowDown
                                }
                                alt="down"
                                style={{
                                    height: active === 4 ? "12px" : "6px",
                                }}
                            />
                        </Box>

                        <Box
                            onClick={() => {
                                dispatch(activeHeader(1));
                                window.location.href = `/${selectedLanguage}/charging-network`;
                            }}
                        >
                            <Text
                                margin="0"
                                cursor="pointer"
                                textColor={
                                    active === 1 ? COLORS.primary : COLORS.white
                                }
                                fontWeight={
                                    active === 1 ? WEIGHT.bold : WEIGHT.regular
                                }
                                fontSize={SIZES.sizteen}
                                marginLeft={SIZES.forty}
                                className="link"
                            >
                                {t("Charging Network")}
                            </Text>
                        </Box>

                        <Box
                            display={smallScreen ? "none" : "flex"}
                            alignItems="center"
                            onClick={() => {
                                dispatch(activeHeader(2));
                                window.location.href = `/${selectedLanguage}/vehicle-intelligence`;
                            }}
                        >
                            <Text
                                margin="0"
                                cursor="pointer"
                                textColor={
                                    active === 2 ? COLORS.primary : COLORS.white
                                }
                                fontWeight={
                                    active === 2 ? WEIGHT.bold : WEIGHT.regular
                                }
                                fontSize={SIZES.sizteen}
                                marginLeft={SIZES.forty}
                                className="link"
                            >
                                {t("Vehicle Intelligence")}
                            </Text>
                        </Box>
                        <Box
                            display={smallScreen ? "none" : "flex"}
                            alignItems="center"
                            onClick={() => {
                                dispatch(activeHeader(3));

                                window.location.href = `/${selectedLanguage}/showroom-locator`;
                            }}
                        >
                            <Text
                                margin="0"
                                cursor="pointer"
                                textColor={
                                    active === 3 ? COLORS.primary : COLORS.white
                                }
                                fontWeight={
                                    active === 3 ? WEIGHT.bold : WEIGHT.regular
                                }
                                fontSize={SIZES.sizteen}
                                marginLeft={SIZES.forty}
                                className="link"
                            >
                                {t("Showroom Locator")}
                            </Text>
                        </Box>
                    </Box>
                    <Box display="flex">
                        <Button
                            isHover={true}
                            background={COLORS.primary}
                            borderRadius="4px"
                            display="flex"
                            alignItems="center"
                            padding={smallScreen ? "10px 5px" : "8px 12px"}
                            margin={smallScreen ? "10px 10px" : "0"}
                            border={COLORS.white}
                            hrb={true}
                            cursor="pointer"
                            onClick={() =>
                                (window.location.href = `/${selectedLanguage}/test-ride`)
                            }
                            onMouseEnter={() => setHover(true)}
                            onMouseLeave={() => setHover(false)}
                            opacity={hover ? 0.9 : 1}
                        >
                            <Text
                                textColor={hover ? COLORS.white : COLORS.black}
                                fontWeight="bold"
                                margin="0"
                                fontSize={"12px"}
                            >
                                {t("Book a Test Ride")}
                            </Text>
                        </Button>
                        {!smallScreen && (
                            <Box
                                display="flex"
                                borderRadius="4px"
                                justifyContent="center" // Center both text and image
                                alignItems="center"
                                background={COLORS.lightBlack}
                                margin={smallScreen ? "10px 20px" : "0px 20px"}
                                padding="0px 2px"
                                onClick={() => {
                                    dispatch(activeHeader(6));
                                    setShowDrop(!showDrop);
                                }}
                            >
                                <Text
                                    marginRight="13px"
                                    marginLeft="13px"
                                    cursor="pointer"
                                    textColor={
                                        active === 6
                                            ? COLORS.primary
                                            : COLORS.white
                                    }
                                    fontWeight={
                                        active === 6
                                            ? WEIGHT.bold
                                            : WEIGHT.regular
                                    }
                                    fontSize={SIZES.twelve}
                                    className="link"
                                >
                                    {selectedLanguage.toUpperCase() ?? "EN"}
                                </Text>
                                <img
                                    src={
                                        active === 6
                                            ? ArrowDownPrimary
                                            : ArrowDown
                                    }
                                    alt="down"
                                    style={{
                                        height: active === 6 ? "12px" : "6px",
                                        marginRight: "13px",
                                    }}
                                />
                            </Box>
                        )}
                        {showDrop && (
                            <LanguageSelector
                                languages={language}
                                small={smallScreen}
                                leave={() => {
                                    dispatch(activeHeader(6));
                                }}
                            />
                        )}
                        <Box
                            display="flex"
                            alignItems="center"
                            cursor="pointer"
                            margin="0 0px"
                            onClick={handleOpenDeawer}
                            onMouseEnter={() => setHoverIcon(true)}
                            onMouseLeave={() => setHoverIcon(false)}
                            opacity={hoverIcon ? 0.9 : 1}
                        >
                            <img src={More} alt="more" />
                        </Box>
                    </Box>
                </Box>
            </Box>
            {openBroucher && (
                <Broucher
                    open={openBroucher}
                    handleClose={() => setOpenBroucher(false)}
                    small={smallScreen}
                />
            )}
        </>
    );
};

export default Header;
